import { render, staticRenderFns } from "./ShippingDetail.vue?vue&type=template&id=24d02364"
import script from "./ShippingDetail.ts?vue&type=script&lang=ts&external"
export * from "./ShippingDetail.ts?vue&type=script&lang=ts&external"
import style0 from "./ShippingDetail.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports